var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "ul",
      {
        staticClass: "list-group",
        staticStyle: { "max-height": "300px", "overflow-y": "auto" },
      },
      [
        _c(
          "li",
          {
            staticClass: "cursor-pointer list-group-item flex-start-center",
            on: {
              click: function ($event) {
                return _vm.$emit("go", 1, _vm.CHECKOUT.EDIT_ADDRESS)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-2x fa-map-marker p-10" }),
            _vm._v(" "),
            _c("div", [_vm._v("Saisissez une nouvelle adresse")]),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-chevron-right p-10 ml-auto" }),
          ]
        ),
        _vm._v(" "),
        _vm.geolocatedAddress
          ? _c(
              "li",
              {
                staticClass: "cursor-pointer list-group-item flex-start-center",
                class: { selected: _vm.tempAddress == _vm.geolocatedAddress },
                on: {
                  click: function ($event) {
                    return _vm.useAddress(_vm.geolocatedAddress)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-2x fa-location-arrow p-10" }),
                _vm._v(" "),
                _c("div", { staticClass: "flex-column" }, [
                  _c("div", [
                    _vm._v("\n                Position actuelle "),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.geolocating,
                          expression: "geolocating",
                        },
                      ],
                      staticClass: "loading",
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.geolocatedAddress.PlusCode) +
                        " " +
                        _vm._s(_vm.geolocatedAddress.Address) +
                        ",\n                " +
                        _vm._s(_vm.geolocatedAddress.Zip) +
                        " " +
                        _vm._s(_vm.geolocatedAddress.City) +
                        ",\n                " +
                        _vm._s(_vm.geolocatedAddress.Country) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ml-auto btn btn-default mr-30",
                    on: {
                      click: function ($event) {
                        return _vm.editAddress(_vm.geolocatedAddress)
                      },
                    },
                  },
                  [
                    _vm._v("\n            Modifier "),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.processingAddress == _vm.geolocatedAddress,
                          expression: "processingAddress==geolocatedAddress",
                        },
                      ],
                      staticClass: "loading",
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isOrderAddressNew()
          ? _c(
              "li",
              {
                staticClass: "cursor-pointer list-group-item flex-start-center",
                class: { selected: _vm.tempAddress == _vm.order.address },
                on: {
                  click: function ($event) {
                    return _vm.useAddress(_vm.order.address)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-2x fa-home p-10" }),
                _vm._v(" "),
                _c("div", { staticClass: "flex-column" }, [
                  _c("div", [_vm._v(_vm._s(_vm.order.address.AdrLabel))]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.order.address.PlusCode) +
                        " " +
                        _vm._s(_vm.order.address.Address) +
                        ",\n                " +
                        _vm._s(_vm.order.address.Zip) +
                        " " +
                        _vm._s(_vm.order.address.City) +
                        ",\n                " +
                        _vm._s(_vm.order.address.Country) +
                        "\n            "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ml-auto btn btn-default mr-30",
                    on: {
                      click: function ($event) {
                        return _vm.editAddress(_vm.order.address)
                      },
                    },
                  },
                  [
                    _vm._v("\n            Modifier "),
                    _c("i", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.processingAddress == _vm.order.address,
                          expression: "processingAddress==order.address",
                        },
                      ],
                      staticClass: "loading",
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.order.client && _vm.order.client.addresses, function (a) {
          return _c(
            "li",
            {
              key: a.AddressId,
              staticClass: "cursor-pointer list-group-item flex-start-center",
              class: {
                selected:
                  _vm.tempAddress && _vm.tempAddress.AddressId == a.AddressId,
              },
              on: {
                click: function ($event) {
                  return _vm.useAddress(a)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-2x fa-home p-10" }),
              _vm._v(" "),
              _c("div", { staticClass: "flex-column" }, [
                _c("div", [_vm._v(_vm._s(a.AdrLabel))]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n                " +
                      _vm._s(a.PlusCode) +
                      " " +
                      _vm._s(a.Address) +
                      ",\n                " +
                      _vm._s(a.Zip) +
                      " " +
                      _vm._s(a.City) +
                      ",\n                " +
                      _vm._s(a.Country) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "ml-auto btn btn-default mr-30",
                  on: {
                    click: function ($event) {
                      return _vm.editAddress(a)
                    },
                  },
                },
                [
                  _vm._v("\n            Modifier "),
                  _c("i", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.processingAddress == a,
                        expression: "processingAddress == a",
                      },
                    ],
                    staticClass: "loading",
                  }),
                ]
              ),
            ]
          )
        }),
        _vm._v(" "),
        !_vm.order.client
          ? _c(
              "li",
              {
                staticClass:
                  "cursor-pointer list-group-item flex-center-center",
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.UiService.showClientLoginModal(true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "Connectez-vous pour choisir une adresse enregistrée"
                    ),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }